module.exports = "/static/assets/e0e5baf4d9616b66aaa2e560cf4cfb51.jpg";